import { StockBalancesAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IGetStockBalancesDTO, IGetStockBalancesResponse } from '@/models/stockBalances.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { STOCK_BALANCES_SLICE_NAME } from './models';

export const getStockBalances = createAsyncThunk<
  IGetStockBalancesResponse,
  IGetStockBalancesDTO,
  { serializedErrorType: IApiError }
>(
  `${STOCK_BALANCES_SLICE_NAME}/getStockBalances`,
  async (data) => {
    const response = await StockBalancesAPI.getStockBalances(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
